import React, { useState, useEffect, useRef } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function ApiRedirect() {
  const notifyError = () => toast('Redirecting to previous transaction page');

  const getRedirectedUrl = () => {
    let search = window.location.search;
    let return_url = localStorage.getItem('return_url');
    let params = new URLSearchParams(search);
    if (!return_url && params.get('return_url')) {
      return_url = params.get('return_url');
    }

    // Only redirect within this site (blocks javascript: and off-site URLs).
    try {
      if (
        return_url &&
        new URL(return_url, window.location.href).origin !== window.location.origin
      ) {
        return_url = null;
      }
    } catch (e) {
      return_url = null;
    }

    if (typeof return_url !== 'undefined' && return_url !== null) {
      const fromKiosk = return_url?.includes('kiosk') || false;

      if (search) {
        search = search + `&hideRushMode=1${fromKiosk ? '&fromKiosk=1' : ''}`;
      } else {
        search = `?hideRushMode=1${fromKiosk ? '&fromKiosk=1' : ''}`;
      }

      const params = new URLSearchParams(search);
      if (params.get('clearCart')) {
        localStorage.removeItem('orders');
        localStorage.removeItem('hw_pending_orderv2');
      }

      window.location.replace(return_url + '' + search);
    }
  };

  useEffect(() => {
    getRedirectedUrl();
  }, []);

  return (
    <>
      <p>Redirecting to Previous Page</p>
    </>
  );
}
